
/** @jsxImportSource @emotion/react */
import React, { useState, useEffect } from 'react';
import DropDown from './dropdown';
import tw, { styled } from 'twin.macro';
import useStorageData from '../../hooks/useStorageData';
import useWorkshop from '../../hooks/useWorkshopMorale';
import useLocalization from '../../hooks/useLocalization';

import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';

import Materials from '../../data/material.json';
import List from '../../data/list.json';

import Products from '../../data/product.json';

import FilterListIcon from '@mui/icons-material/FilterList';
import Tooltip from '@mui/material/Tooltip';
import Chip from '@mui/material/Chip';

const Product = ({ dataIndex, measure }) => {
  const { productData, setProductData, productPriceData, productReadyData, productBonusData, materialData,productList, sortPreset } = useStorageData();
  const { workshop, setWorkshop, currentWorkshop, currentSchedule } = useWorkshop();
  const [ error, setError ] = useState(false);

  const dataKey = productList[dataIndex];
  const data = Products[dataKey];

  const { t, lang } = useLocalization();

  

  let popularity = productData[dataKey].popularity;
  let demand = productData[dataKey].demand;

  let currentPrice = productPriceData[dataKey];
  let revenuePerHour = Math.floor(currentPrice / data.crafttime);

  let hasBonus = productBonusData.indexOf(dataKey) > -1;


  useEffect(() => {
    measure();
  },[sortPreset,measure])



  return(
    <div css={tw`pb-4 pr-4 pl-11`}>
      <ItemWrapper key={dataKey}>
        <div css={tw`w-full relative`}>
          {!error ? 
            <Tooltip title={t(`addToSchedule`)} arrow placement="top">
              <AddButton aria-label={t(`addToSchedule`)} size="small" onClick={() => {
                let currentTimeSpent = 0;
                currentSchedule.forEach((item) => {
                  currentTimeSpent += Products[item].crafttime
                });

                if(currentTimeSpent + Products[dataKey].crafttime <= 24)
                {
                  setWorkshop({
                    key : 'addSchedule',
                    target : currentWorkshop,
                    value : dataKey
                  })
                } else{
                  setError(true);
                  setTimeout(() => {
                    setError(false)
                  },2000);
                }
              }}>
                <AddIcon fontSize="inherit" />
              </AddButton>
            </Tooltip>
          : 
            <Tooltip title={t(`scheduleFull`)} arrow placement="top">
              <ErrorAddButton aria-label={t(`scheduleFull`)} size="small" >
                <AddIcon fontSize="inherit" />
              </ErrorAddButton>
            </Tooltip>
          }
          <div css={tw`flex justify-between`}>
            <NameCol>
              <ItemImg src={data.icon} />
              <span>{data.label[lang]}</span>
              <ChipWrapper>{data.type.map((key) => <TypeChip key={`chip_${dataKey}_${key}`} setcolor={List.Type[key].color} variant="outlined" label={List.Type[key].label[lang]} size="small" />)}</ChipWrapper>
            </NameCol>
            <div>
            <ItemHeader>
              <DropDownWrapper>
                <ItemCol css={tw`
                  w-[200px]
                  text-right
                `}>
                  {hasBonus && <Chip color="error" label={t(`hasBonus`)} />}
                  {productReadyData[dataKey] && <Chip color="success" label={t(`craftable`)} css={tw`ml-2`}/>}
                </ItemCol>
                <div>
                  <DropDown label={t(`popularity`)} list={List.Popularity} value={popularity} handleChange={(e) => {
                    setProductData({
                      key : dataKey,
                      target : 'popularity',
                      value : e.target.value
                    });
                  }}/>
                </div>
                <div>
                  <DropDown label={t(`demand`)} list={List.Demand} value={demand} handleChange={(e) => {
                    setProductData({
                      key : dataKey,
                      target : 'demand',
                      value : e.target.value
                    });
                  }}/>
                </div>
              </DropDownWrapper>
            </ItemHeader>
            <ItemContent>
              
              <ValueCol>
                <span>{t(`baseValue`)}：{data.value[workshop.workshops[currentWorkshop].rank] ? data.value[workshop.workshops[currentWorkshop].rank] : Math.floor(data.value[1] * (1 + 0.1 * (workshop.workshops[currentWorkshop].rank - 1)))} <SortButton direction={'asc'} type={"value"}/></span>
              </ValueCol>
              <ItemCol>
                <span>{t(`crafttime`)}：{data.crafttime} <SortButton direction={'asc'} type={"time"} /></span>
              </ItemCol>
              <ItemCol>
                {t(`revenue`)}：{currentPrice} <SortButton direction={'asc'} type={"price"}/>
              </ItemCol>
              <ItemCol>
                {t(`revenuePerHour`)}：{revenuePerHour} <SortButton direction={'asc'} type={"revenuePerHour"} />
              </ItemCol>
            </ItemContent>
            </div>
          </div>
          
        </div>
        {t(`material`)}：
        {Object.keys(data.material).map((material,j) => 
          { 
            if(Materials[material])
            {
              return(<MaterialItem key={`material_${dataKey}_${j}`}>
              <MaterialItemImage src={Materials[material].icon} />
              {`${Materials[material].label[lang]} : ${materialData[material]} / ${data.material[material]}`} 
            </MaterialItem>);
            } else {
              return(<MaterialItem key={`material_${dataKey}_${j}`}>
              {material} 
            </MaterialItem>);
            }
          }

        )}
    </ItemWrapper>  
  </div>  
  );

}

const SortButton = ({ type }) => {
  const { sortPreset, setSortPreset } = useStorageData();

  return (<SortButtonWrapper className={sortPreset.sortBy === type ? `active ${sortPreset.order}` :``} onClick={(e) => {
    e.stopPropagation();
    if(sortPreset.sortBy === type)
    {
      setSortPreset({
        key : 'order',
        value : sortPreset.order === 'asc' ? 'dsc' : 'asc'
      });
    }
    else{
      setSortPreset({
        key : 'sortBy',
        value : type
      });
      setSortPreset({
        key : 'order',
        value : 'dsc'
      });
    }
  }}>
    <FilterListIcon fontSize="small" />
  </SortButtonWrapper>)
}

export default Product

const AddButton = styled(IconButton)`
  ${tw`
    left-[-60px]
    absolute
    bg-blue-100 
    hover:bg-blue-300
  `}
`

const ErrorAddButton = styled(AddButton)`
  ${tw`
    bg-red-300
    hover:bg-red-300
  `}
`

const SortButtonWrapper = styled.div`
  ${tw`
    inline-block
    opacity-20
    cursor-pointer
    w-5
    h-5
    align-middle
    -mt-1
    
  `}

  &:hover{
    ${tw`
      opacity-70
    `}
  }

  &.active{
    ${tw`
      opacity-100
    `}
  }

  &.asc{
    ${tw`
      rotate-180
    `}
  }

  svg{
    ${tw`
      align-top
    `}
  }
`

const ItemWrapper = styled.div`
  ${tw`
    border
    p-4
    rounded
  `}
`

const ItemHeader = styled.div`
  ${tw`
    flex
    justify-between
    align-middle
  `}
`

const ItemContent = styled.div`
  ${tw`
    flex
    justify-end
    mt-4
    gap-6
  `}
`

const ItemCol = styled.div`
  ${tw`
    h-[40px]
    leading-[40px]
    flex-col
    justify-center
  `}
`

const NameCol = styled(ItemCol)`
  ${tw`
    font-black
    text-[18px]
    pr-4
    leading-[24px]
    relative
    pl-[67px]
    h-auto
  `}
`

const ValueCol = styled(ItemCol)`

`

const MaterialItem = styled.div`
  ${tw`
    pl-4
    h-7
    leading-[24px]
    pb-1
  `}
`

const MaterialItemImage = styled.img`
  ${tw`
    w-6
    h-6
    inline-block
    mr-2
  `}
`

const DropDownWrapper = styled.div`
  ${tw`
    flex
    gap-4
    
  `}
`

const TypeChip = styled(Chip)`
  color : ${props => props.setcolor};
  border-color : ${props => props.setcolor};

  ${tw`
    mr-2
  `}
`

const ChipWrapper = tw.div`
  mt-1
`

const ItemImg = tw.img`
  w-[55px]
  h-[55px]
  absolute
  left-0
  top-0
`